module.exports = __webpack_public_path__ + "img/owlbg.195974b1.svg";